<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <div v-if="employeesData">
      <div class="row">
        <EmployeeCard
          v-for="employee in employeesData"
          :key="employee.employeeToken"
          :employeeData="employee"
          v-on:setEmployeeData="employeeData.fillData($event)"
        />
      </div>
      <Pagination
        v-if="!isLoading"
        :paginationData="paginationData"
        v-on:changePage="changePage"
      />
      <EmployeeInfo :employeeData="employeeData" />
      <EmployeeDelete
        :employeeData="employeeData"
        v-on:refresh="getAllEmployees()"
      />
    </div>

    <EmployeeFloatBtns
      :textSearch="textSearch"
      :employeeGenderToken="employeeGenderToken"
      :employeeTypeToken="employeeTypeToken"
      v-on:search="search"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS, PAGE_SIZE } from "@/utils/constants";
import axios from "axios";
import EmployeeCard from "@/components/employees/EmployeeCard.vue";
import EmployeeInfo from "@/components/employees/EmployeeInfo.vue";
import EmployeeDelete from "@/components/employees/EmployeeDelete.vue";
import EmployeeFloatBtns from "@/components/employees/EmployeeFloatBtns.vue";
import Pagination from "@/components/general/Pagination.vue";
import Employee from "@/models/employees/Employee";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "Employees",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EmployeeCard,
    EmployeeInfo,
    EmployeeDelete,
    EmployeeFloatBtns,
    Pagination,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      textSearch: "",
      employeeGenderToken: "",
      employeeTypeToken: "",
      paginationData: {
        totalPages: 1,
        totalItems: 0,
        countItemsInPage: 0,
        selfPage: 1,
      },
      employeesData: null,
      employeeData: new Employee(),
      filter: {
        token: "",
      },
    };
  },
  methods: {
    changePage(page) {
      this.paginationData.selfPage = page;
      this.getAllEmployees();
    },
    search(text, token) {
      this.textSearch = text;
      this.filter.token = token;
      this.getAllEmployees();
    },
    async getAllEmployees() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `/Employees/GetAllEmployees?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}&page=${this.paginationData.selfPage}&paginationStatus=true&pageSize=${PAGE_SIZE}&filterStatus=true&establishmentRoleToken=${this.filter.token}&textSearch=${this.textSearch}`
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.paginationData = {
            totalPages: response.data.pagination.totalPages,
            totalItems: response.data.pagination.totalItems,
            countItemsInPage: response.data.pagination.countItemsInPage,
            selfPage: response.data.pagination.selfPage,
          };
          this.employeesData = response.data.employeesData;
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.employeesData = null;
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.employeesData = null;
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.employeesData = null;
          this.exceptionMsg = response.data.msg;
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.employeesData = null;
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {
    this.getAllEmployees();
  },
};
</script>
